const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const styles = require("./styles/MainTrainerBorder.css");
const {FLAGS} = require("../util/GlobalFlags");

module.exports = createReactClass({
	displayName: "MainTrainerBorder",

	propTypes: {
		style: PT.object.isRequired,
		containerDims: PT.shape({
			width: PT.number.isRequired,
			height: PT.number.isRequired,
			left: PT.number.isRequired,
			top: PT.number.isRequired,
			windowWidth: PT.number.isRequired,
			windowHeight: PT.number.isRequired,
		}).isRequired,
	},

	//TODO: The border does not look good while resizing the page. We may want to
	//position it differently & fill in cyan around the corners so it looks
	//better on resize.

	render: function() {
		if (FLAGS.cleanMode) {
			return null;
		}
		let mainClass = styles.main;
		//If the ratio of width to height is enough that only a bit of the dark
		//blue argyle would be visible, cover it up with the cyan.
		const windowRatio =
			this.props.containerDims.windowHeight /
			this.props.containerDims.windowWidth;
		if (windowRatio > 0.67 && windowRatio < 0.87) {
			mainClass += " " + styles.cyanBackground;
		}

		return (
			<div className={mainClass} style={this.props.style}>
				<div className={styles.cyanContainerLeft}>
					<div className={styles.leftTopTriangle} />
					<div className={styles.leftBottomTriangle} />
				</div>
				<div className={styles.whiteBorderLeft} />
				<div className={styles.cyanContainerRight}>
					<div className={styles.rightTopTriangle} />
					<div className={styles.rightBottomTriangle} />
				</div>
				<div className={styles.whiteBorderRight} />
				<div className={styles.cyanContainerTop}>
					<div className={styles.topLeftTriangle} />
					<div className={styles.topRightTriangle} />
				</div>
				<div className={styles.whiteBorderTop} />
				<div className={styles.cyanContainerBottom}>
					<div className={styles.bottomRightTriangle} />
					<div className={styles.bottomLeftTriangle} />
				</div>
				<div className={styles.whiteBorderBottom} />
			</div>
		);
	},
});
